import { Rule } from '@webkit/validation/value';
import dayjs from 'dayjs';

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export const afterWithDateValue = (date: dayjs.Dayjs, inclusive: boolean = false, error?: string) =>
    ({
        id: 'after',
        validator: value => !value || (inclusive ? value.isSameOrAfter(date) : value.isAfter(date)),
        error: () => error || `Must be ${inclusive ? 'on or ' : ''}after ${date.format('M/D/YYYY')}`,
    } as Rule<dayjs.Dayjs | null>);
